import type { Tagged } from "@-/com.npmjs.type-fest";
import arrayLength from "@-/com.npmjs.extra-array__length";
import { createGate } from "@-/dev.improve.haniverse.lib.gate";
import type { IndexedLevel } from "#levels-list-entry";

/** Proof that the sheet has a level to show: the active position resolves to a level in the list. */
export type LevelDetailsSheetGate = Tagged<
  { activeLevelPosition: number; indexedLevel: IndexedLevel; levelCount: number },
  "LevelDetailsSheetGate"
>;

/**
 * `null` = the designed hidden state: no level is active, or the active position no longer resolves
 * (the list shrank under it, e.g. after a filter change).
 */
export function getLevelDetailsSheetGate(
  levelsList: readonly IndexedLevel[],
  activeLevelPosition: number | null,
): LevelDetailsSheetGate | null {
  if (activeLevelPosition === null) {
    return null;
  }
  const indexedLevel = levelsList[activeLevelPosition];
  return indexedLevel === undefined
    ? null
    : createGate<LevelDetailsSheetGate>({
        activeLevelPosition,
        indexedLevel,
        levelCount: arrayLength(levelsList),
      });
}
